import { render, staticRenderFns } from "./ModalBanAbusing.vue?vue&type=template&id=0603265a&scoped=true"
import script from "./ModalBanAbusing.vue?vue&type=script&lang=js"
export * from "./ModalBanAbusing.vue?vue&type=script&lang=js"
import style0 from "./ModalBanAbusing.vue?vue&type=style&index=0&id=0603265a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0603265a",
  null
  
)

export default component.exports